import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const WindowLevelMenuItem = ({ title, subtitle, isSelected, index }) => (
  <>
    <div
      className={classNames(
        'hover:bg-primary-dark flex h-8 w-full flex-row items-center p-3',
        isSelected && 'bg-primary-dark'
      )}
    >
      <span className="mr-2 text-base text-common-bright whitespace-nowrap">{title}</span>
      <span className="flex-1 text-sm font-light text-aqua-pale whitespace-nowrap">{subtitle}</span>
      <span className="ml-5 text-sm text-primary-active whitespace-nowrap">{index + 1}</span>
    </div>
  </>
);

WindowLevelMenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
};

export default WindowLevelMenuItem;
